import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    open: { type: Boolean, default: false },
    menu: { type: String, default: "" },
    closeDelay: { type: Number, default: 200 },
  };

  connect() {
    this.closeTimeout = null;

    // Dynamically create targets based on data attributes
    this.menuTargets = Array.from(
      this.element.querySelectorAll("[data-menu-target]")
    );
  }

  toggleMenu(event) {
    const menuName = event.currentTarget.dataset.menu;

    this.openValue = true;
    this.menuValue = menuName;
    this.repositionDropdown(event.currentTarget);
  }

  repositionDropdown(navElement) {
    this.clearCloseTimeout();

    const dropdown = this.findTarget("dropdown");
    dropdown.style.left = `${navElement.offsetLeft}px`;
    dropdown.style.marginLeft = `${navElement.offsetWidth / 2}px`;
  }

  handleMouseLeave() {
    this.closeTimeout = setTimeout(() => {
      this.closeMenu();
    }, this.closeDelayValue);
  }

  clearCloseTimeout() {
    clearTimeout(this.closeTimeout);
  }

  closeMenu() {
    this.openValue = false;
    this.menuValue = "";
  }

  // Lifecycle hooks for open/close
  openValueChanged() {
    const dropdown = this.findTarget("dropdown");
    if (dropdown) {
      dropdown.hidden = !this.openValue;
    }
  }

  menuValueChanged() {
    // Hide all menu targets
    (this.menuTargets ?? []).forEach((target) => {
      target.hidden = target.dataset.menuTarget !== this.menuValue;
    });
  }

  // Utility method to find targets dynamically
  findTarget(targetName) {
    return this.element.querySelector(`[data-${targetName}-target]`);
  }
}
